/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum OralSupplementsExecuteTimeModalAliases {
  ACCORDION_INFORMATION = 'accordion-information',
  BUTTON_EXECUTE = 'button-execute',
  CONTENT_INFORMATION_HEADER = 'content-information-header',
  DATE_HOUR_FIELD = 'date-hour-field',
  DATE_HOUR_INPUT = 'date-hour-input',
  DOSE_EXECUTED_FIELD = 'dose-executed-field',
  DOSE_EXECUTED_INPUT = 'dose-executed-input',
  GLOBAL_ACTIONS_EXECUTE = 'global-actions-execute',
  INFORMATION_FORM = 'information-form',
  INFORMATION_TEXT = 'information-text',
  JUSTIFICATION_FIELD = 'justification-field',
  JUSTIFICATION_TEXT_AREA = 'justification-text-area',
  ORAL_SUPPLEMENTS_EXECUTE_LAYOUT = 'oral-supplements-execute-layout',
  PANEL_ACCORDION_INFORMATION = 'panel-accordion-information',
  PANEL_FORM_INFORMATION = 'panel-form-information',
  PANEL_INFORMATION_HEADER = 'panel-information-header',
  TEXT_MEDICATION_DATE = 'text-medication-date',
  TEXT_MEDICATION_INFORMATION = 'text-medication-information',
  UNITY_EXECUTED_FIELD = 'unity-executed-field',
  UNITY_EXECUTED_INPUT = 'unity-executed-input',
}
export { OralSupplementsExecuteTimeModalAliases };
